import { Outlet } from "react-router-dom";
import { useState } from "react";

export default function AuthWrapper() {
  const [email, setEmail] = useState();

  return <Outlet context={[email, setEmail]} />;
}
